// Enums
import { ChannelOptions } from './channel-options.enum';
import { LineStyle } from './line-style.enum';

export class Channel {
	id?: number;
	label?: string;
	units?: string;
	colorHex?: string;
	precision?: number;
	min?: number;
	max?: number;
	minY?: number;
	maxY?: number;
	highDanger?: number;
	highWarning?: number;
	lowDanger?: number;
	lowWarning?: number;
	options?: ChannelOptions;
	optionArray: string[] = [];
	lineStyle?: LineStyle;
	lineWeight?: number;
	display: boolean;
	showGraph: boolean;
	seq: number;
	
	clear() {
		this.id = undefined;
		this.label = '';
		this.units = '';
		this.colorHex = '';
		this.precision = 0;
		this.min = undefined;
		this.max = undefined;
		this.minY = undefined;
		this.maxY = undefined;
		this.highDanger = undefined;
		this.highWarning = undefined;
		this.lowDanger = undefined;
		this.lowWarning = undefined;
		this.options = ChannelOptions.None;
		this.lineStyle = LineStyle.Straight;
		this.lineWeight = 1;
	}
}
